import * as React from 'react'
import type { AnyFieldApi } from '@tanstack/react-form'
import { cn } from '@/utils/cn'
import { Label } from '@/components/ui/label'

export interface FormFieldProps {
  field: AnyFieldApi
  label?: React.ReactNode
  required?: boolean
  description?: React.ReactNode
  className?: string
  children: React.ReactNode
}

function formatError(err: unknown): string {
  if (!err) return ''
  if (typeof err === 'string') return err
  if (typeof err === 'object' && 'message' in err) {
    return String((err).message)
  }
  return String(err)
}

export function FormField({
  field,
  label,
  required,
  description,
  className,
  children,
}: FormFieldProps) {
  const errors = field.state.meta.errors
  const showError = field.state.meta.isTouched && errors.length > 0
  const errorMessage = showError ? formatError(errors[0]) : null

  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      {label && (
        <Label htmlFor={field.name} required={required}>
          {label}
        </Label>
      )}
      {children}
      {description && !showError && (
        <p className="text-xs text-muted-foreground">{description}</p>
      )}
      {errorMessage && (
        <p className="text-xs text-destructive">{errorMessage}</p>
      )}
    </div>
  )
}
